import { inject, Injectable, signal } from '@angular/core';
import { env } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ResponseUser } from '../../../shared/models/utente';
import { mainSrc, ProprietarioCollezione, wizardResponse, IndirizzoSuggestion, IndirizzoSuggestionResponse } from '../../../shared/models/wizardData';

@Injectable({
  providedIn: 'root',
})
export class WizardFormSubmitService {
  constructor() {}

  private http = inject(HttpClient);
  private urlUtente = `${env.api.baseUrlProtected}/utente`;
  private urlWizard = `${env.api.baseUrlProtected}/collezione-digitale`;
  private urlProprietario = `${env.api.baseUrlProtected}/proprietario`;

  idCollezioneModal = signal<any>(1);
  useModal = signal(false);

  setResponse(data: any) {
    this.idCollezioneModal.set(data);
  }
  getResponse() {
    return this.idCollezioneModal();
  }

  // step 1


  getAllUtenti(data:any): Observable<ResponseUser[]> {
    return this.http.get<ResponseUser[]>(`${this.urlProprietario}`,{ params: data });
  }

  setupTitolo(data: mainSrc): Observable<wizardResponse> {
    return this.http.post<wizardResponse>(`${this.urlWizard}`, data);
  }

  // chiamata necessaria per fare il setup completo della collezione vista la gestione a modale del titolo
  modifyCollezione(data:mainSrc):Observable<wizardResponse>{
    return this.http.put<wizardResponse>(`${this.urlWizard}`, data);
  }

  setupProprietario(data:ProprietarioCollezione):Observable<any>{
    return this.http.post<any>(`${this.urlProprietario}`, data)
  }

  updateProprietario(data:ProprietarioCollezione):Observable<any>{
    return this.http.put<any>(`${this.urlProprietario}`, data)
  }

  // step 2
  getCollezioneById(id:number):Observable<wizardResponse>{
    return this.http.get<wizardResponse>(`${this.urlWizard}/${id}`)
  }

  setupCollezioneDigitale(data:mainSrc):Observable<wizardResponse>{
     return this.http.put<wizardResponse>(`${this.urlWizard}`, data);
  }

  // step 3

  // setup se info patrimonio presente
  setupPatrimonioFisico(data:mainSrc):Observable<wizardResponse>{
    return this.http.put<wizardResponse>(`${this.urlWizard}`, data)
  }

  getAllProprietari(data:any): Observable<ResponseUser[]> {
    return this.http.get<ResponseUser[]>(`${this.urlProprietario}`,{ params: data });
  }

  getProprietarioById(id: number): Observable<any> {
    const params = new HttpParams().set('idEqual', id.toString());
    return this.http.get<any>(`${this.urlProprietario}`, { params });
  }

  // step 4

  // setup e put finale

  setupVisMappa(data:mainSrc):Observable<wizardResponse>{
    return this.http.put<wizardResponse>(`${this.urlWizard}`, data)
  }

  // auto complete comuni
  indirizzoSuggestion(data: string): Observable<IndirizzoSuggestion[]> {
    const params = new HttpParams().set('term', data);
    return this.http
      .get<IndirizzoSuggestionResponse>(`${env.api.baseUrlPublic}/indirizzo-suggestion`, { params })
      .pipe(map(res => res.elements ?? []));
  }

}
